// Material Kit 2 React pages
import InvestigationList from "presentation/components/InvestigationListPage";

export default function InvestigationListPage() {
  return <InvestigationList />;
}
